let snackbar = null;

export const setSnackbar = (snac) => {
    snackbar = snac;
};

export const showSnackbar = ({ message, type = "error" }) => {
    if (snackbar) {
        if (type === "error") snackbar.showError(message);
        else snackbar.setMessage(message);
    } else {
        // fallback (optional)
        alert(message);
    }
};